
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.714 24h-3.428v-3.6a8.551 8.551 0 01-3.009-1.254L4.726 21.7 2.3 19.275l2.551-2.552A8.481 8.481 0 013.6 13.714H0v-3.428h3.6a8.515 8.515 0 011.253-3.007L2.3 4.728 4.728 2.3l2.551 2.555A8.422 8.422 0 0110.286 3.6V0h3.428v3.6a8.424 8.424 0 013.007 1.251L19.272 2.3 21.7 4.728l-2.555 2.551a8.458 8.458 0 011.255 3.007H24v3.428h-3.6a8.479 8.479 0 01-1.254 3.011l2.554 2.55-2.428 2.425-2.551-2.551a8.526 8.526 0 01-3.007 1.251V24zM12 6.857a5.143 5.143 0 100 10.286 5.143 5.143 0 000-10.286z"}})])
          )
        }
      }
    